import React, { useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import CreatableSelect from "react-select/creatable";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import { FREELANCER } from "../../Router/paths";
import { axiosInstance } from "../../config/https";
import { useLoader, useModal } from "../../context/LoaderContext";
import { skills } from "../../utils";
import User from "../../assets/images/james-img.png";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "40px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

// const SocialMedia = [
//   { value: "Google", label: "Google" },
//   { value: "Facebook", label: "Facebook" },
//   { value: "Instagram", label: "Instagram" },
// ];

export default function ProfileSettingsComp() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { startLoader, stopLoader } = useLoader();
  const { openModal } = useModal();
  const {
    getRootProps,
    getInputProps,
    acceptedFiles,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({ accept: { "image/*": [] } });
  const [description, setDescription] = useState("");
  const [city, setCity] = useState("");
  const [education, setEducation] = useState("");
  const [educationFrom, setEducationFrom] = useState("");
  const [educationTo, setEducationTo] = useState("");
  const [portfolioLink, setPortfolioLink] = useState("");
  const [jobSkills, setJobSkills] = useState([]);
  const [Resume, setResume] = useState(null);
  const [profile, setProfile] = useState(null);
  const ProfileInput = useRef();

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const handleInputChange = (e, func) => {
    func(e.target.value);
  };
  // console.log("state", state);
  const handleSubmit = (e) => {
    e.preventDefault();
    startLoader();
    const row = state;
    axiosInstance
      .post("/api/user/register/", row)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (Data.status_code === 200 || Data.status_code === 201) {
          axiosInstance.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${Data.token.access}`;
          localStorage.setItem("token", Data.token.access);
          createAccount();
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  // const SK = jobSkills.map((e) => {
  //   return {
  //     name: e.value,
  //   };
  // });

  const createAccount = () => {
    startLoader();
    const formData = new FormData();
    formData.append("description", description);
    formData.append("education", education);
    formData.append("from_year", educationFrom);
    formData.append("to_year", educationTo);
    formData.append("city", city);
    formData.append("personal_website", portfolioLink);
    formData.append("resume", Resume);
    jobSkills.map((e) => formData.append("skills", e.value));
    acceptedFiles.map((e) => formData.append("images", e));
    formData.append("profile_picture", profile);
    axiosInstance
      .post("/api/seller/sellers/", formData)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          localStorage.setItem("user", JSON.stringify(Data));
          openModal(
            "congrats", //gif url
            "Congratulations!", //title
            Data.msg ||
              "Your registration is now complete. Thank you for choosing our services. We look forward to serving you with excellence.!" //subtitle
          );
          // toast.success(Data.msg || "Signup Successfully!");
          navigate(FREELANCER.dashboard);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const onChange = (e) => {
    setJobSkills(e);
  };

  // const onChangeSocialLink = (e) => {
  //   setSocialLink(e);
  // };

  return (
    <section className="contractor-profile-sec pc-p-3">
      <div className="container align-items-center justify-content-center">
        <div className="row align-items-center">
          <div className="col-lg-12 col-12">
            <div className="profile-main-box">
              <div className="profile-sec-box">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-3">
                    <div className="client-box">
                      <img
                        src={profile ? URL.createObjectURL(profile) : User}
                        alt="pro img"
                      />
                      <input
                        type="file"
                        ref={ProfileInput}
                        onChange={(e) => setProfile(e.target.files[0])}
                        hidden
                      />
                      <div className="edit-icon">
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => ProfileInput.current.click()}
                        >
                          <i>
                            <FaPencilAlt />
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="primary-heading color-dark">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="client-profile">
                      <form className="profile-form" onSubmit={handleSubmit}>
                        <div className="col-lg-12">
                          <div className="row"></div>
                          <div className="form-group">
                            <div className="form-group">
                              <label htmlFor="">Description:-</label>
                              <textarea
                                className="form-control"
                                rows={10}
                                placeholder="Write Your description here..."
                                defaultValue={""}
                                onChange={(e) =>
                                  handleInputChange(e, setDescription)
                                }
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="">City</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={"Enter City"}
                                onChange={(e) => handleInputChange(e, setCity)}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="">Education</label>
                              <input
                                type="text"
                                className="form-control mt-3"
                                placeholder="Ned University Computer Engineering"
                                onChange={(e) =>
                                  handleInputChange(e, setEducation)
                                }
                              />
                              <input
                                type="date"
                                className="form-control mt-3"
                                placeholder="from 2021 "
                                onChange={(e) =>
                                  handleInputChange(e, setEducationFrom)
                                }
                              />
                              <input
                                type="date"
                                className="form-control mt-3"
                                placeholder="to-2022"
                                onChange={(e) =>
                                  handleInputChange(e, setEducationTo)
                                }
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="">
                                Personal Portfolio/ Website link:-
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="https://example.com"
                                onChange={(e) =>
                                  handleInputChange(e, setPortfolioLink)
                                }
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="">Resume:-</label>
                              <br />
                              <input
                                type="file"
                                className="w-100"
                                onChange={(e) => setResume(e.target.files[0])}
                              />
                            </div>

                            <div className="form-group">
                              <label htmlFor="">Add Skills:-</label>
                              <CreatableSelect
                                isMulti
                                options={skills}
                                onChange={onChange}
                              />
                              {/* <div className="specialities-box">
                                <ul>
                                  <li>
                                    <a href="javascript:void(0)">
                                      Appliance{" "}
                                      <span>
                                        <i>
                                          <FaTimes />
                                        </i>
                                      </span>{" "}
                                    </a>
                                  </li>
                                  <li>
                                    <a href="javascript:void(0)">
                                      Architectural Design
                                      <span>
                                        <i>
                                          <FaTimes />
                                        </i>
                                      </span>
                                    </a>
                                  </li>
                                  <li>
                                    <a href="javascript:void(0)">
                                      Asphalt{" "}
                                      <span>
                                        <i>
                                          <FaTimes />
                                        </i>
                                      </span>
                                    </a>
                                  </li>
                                </ul>
                              </div> */}
                            </div>
                            {/* <div className="form-group">
                              <label htmlFor="">Add Socal link:-</label>
                              <CreatableSelect
                                isMulti
                                options={SocialMedia}
                                onChange={onChangeSocialLink}
                              />
                            </div> */}
                            {/* <div className="form-group mc-b-4 pb-5 border-bottom">
                                          <h5>Upload Resume:-</h5>
                                          <label htmlFor="picture-upload" className="picture-upload">
                                              <p className="mb-0">Your Resume</p>
                                              <i className="fa fa-cloud-upload"></i>
                                          </label>
                                          <input type="file" id="picture-upload" className="d-none">
                                      </div>
                                      <div className="payment-metod-sec"> */}
                            <div className="row align-items-center">
                              <div className="col-md-12">
                                <h5 className="mb-3">upload Projects:-</h5>
                                <div {...getRootProps({ style })}>
                                  <input {...getInputProps()} />
                                  <p className="mb-0">
                                    Drag 'n' drop some files here, or click to
                                    select files
                                  </p>
                                </div>
                                <aside>
                                  <h5>Files</h5>
                                  <div className="row">
                                    {acceptedFiles.map((e, i) => (
                                      <div className="col-md-2" key={i}>
                                        <img
                                          src={URL.createObjectURL(e)}
                                          width={150}
                                          alt="img"
                                        ></img>
                                      </div>
                                    ))}
                                  </div>
                                </aside>
                              </div>
                              {/* <div className="col-lg-6">
                                <div className="file-drag-area">
                                  <div className="drag-icon">
                                    <label htmlFor="file-default">
                                      <i>
                                        <FaPlusCircle />
                                      </i>
                                    </label>
                                    <input type="file" id="file-default" />
                                  </div>
                                </div>
                                <div className="project-file-title  primary-heading color-dark pc-p-6">
                                  <Link
                                    to="#"
                                    className="primary-btn primary-bg"
                                  >
                                    add new projects
                                  </Link>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="file-drag-area">
                                  <div className="drag-icon">
                                    <label htmlFor="file-default">
                                      <i>
                                        <FaPlusCircle />
                                      </i>
                                    </label>
                                    <input type="file" id="file-default" />
                                  </div>
                                </div>
                              </div> */}
                              <div className="col-md-12 text-end">
                                <div className="project-file-title text-right primary-heading color-dark pc-p-6">
                                  <button className="primary-btn primary-bg">
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
